import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import { toast } from "react-toastify";
import WorkShiftService from "../../../../../services/Company/WorkShiftService";
import ScrollPagination from "../../../../common/ScrollPagination";

const AddBranchModal = ({
	addModal,
	setAddModal,
	item,
	setShouldUpdate,
	Service,
}) => {
	const [formData, setFormData] = useState({
		nameEn: "",
		nameAr: "",
		openAnyTime: false,
		latitude: "",
		longitude: "",
		allowedRadiusMeters: "",
		workShiftIds: [],
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			Service.find(item?.id).then((res) => {
				if (res?.status) {
					const response = res?.data?.data;
					setIsAdd(false);
					setFormData({
						id: item?.id,
						nameEn: response?.nameEn,
						nameAr: response?.nameAr,
						longitude: response?.longitude,
						latitude: response?.latitude,
						openAnyTime: response?.openAnyTime,
						allowedRadiusMeters: response?.allowedRadiusMeters,
						workShiftIds: response?.workShifts?.map((info) => ({
							label: info?.name,
							value: info?.id,
						})),
					});
				}
			});
		}
	}, [item]);

	const submit = (e) => {
		e.preventDefault();
		if (!formData?.openAnyTime && !formData?.workShiftIds?.length) {
			toast.error("Select WorkShift First");
			return;
		}
		let data = {
			nameEn: formData?.nameEn,
			nameAr: formData?.nameAr,
			latitude: formData?.latitude,
			longitude: formData?.longitude,
			openAnyTime: formData?.openAnyTime,
			allowedRadiusMeters: formData?.allowedRadiusMeters,
		};
		if (formData?.openAnyTime) {
			data["workShiftIds"] = [];
		} else {
			data["workShiftIds"] = formData?.workShiftIds?.map((res) => res?.value);
		}

		setLoading(true);
		if (isAdd) {
			Service.create(data)
				?.then((res) => {
					if (res && res?.status === 201) {
						toast.success(`Branch Added Successfully`);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			Service.update(formData?.id, data)
				?.then((res) => {
					if (res && res?.status === 200) {
						toast.success(`Branch Updated Successfully`);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={lang === "en" ? "en fade" : "ar fade"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#000",
										fontSize: "22px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.branch}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						{/* English Name */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.english_name}
								type="text"
								placeholder={Translate[lang]?.english_name}
								bsSize="lg"
								name="nameEn"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.nameEn}
								onChange={(e) =>
									setFormData({ ...formData, nameEn: e.target.value })
								}
							/>
						</Col>
						{/* Arabic Name */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.arabic_name}
								type="text"
								placeholder={Translate[lang]?.arabic_name}
								bsSize="lg"
								name="nameAr"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.nameAr}
								onChange={(e) =>
									setFormData({ ...formData, nameAr: e.target.value })
								}
							/>
						</Col>
						{/* latitude */}
						<Col md={3}>
							<AvField
								label={Translate[lang]?.latitude}
								type="number"
								placeholder={Translate[lang]?.lat}
								bsSize="lg"
								name="latitude"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.latitude}
								onChange={(e) =>
									setFormData({ ...formData, latitude: e.target.value })
								}
							/>
						</Col>
						{/* longitude */}
						<Col md={3}>
							<AvField
								label={Translate[lang]?.longitude}
								type="number"
								placeholder={Translate[lang]?.lon}
								bsSize="lg"
								name="longitude"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.longitude}
								onChange={(e) =>
									setFormData({ ...formData, longitude: e.target.value })
								}
							/>
						</Col>
						{/* Allowed Radius Meters */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.allowed_radius_meters}
								type="number"
								placeholder={Translate[lang]?.allowed_radius_meters}
								bsSize="lg"
								name="allowedRadiusMeters"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.allowedRadiusMeters}
								onChange={(e) =>
									setFormData({
										...formData,
										allowedRadiusMeters: e.target.value,
									})
								}
							/>
						</Col>
						{/* Open Any Time */}
						<Col md={12} className="d-flex gap-12 mb-3 mt-3">
							<Form.Check
								type="switch"
								id="custom-switch"
								checked={formData?.openAnyTime}
								onChange={(e) =>
									setFormData({ ...formData, openAnyTime: e.target.checked })
								}
							/>
							<label className="m-0" htmlFor="custom-switch">
								{Translate[lang].open_any_time}
							</label>
						</Col>
						{/* WorkShift */}
						{!formData?.openAnyTime && (
							<Col md={12}>
								<label className="text-label">
									{Translate[lang]?.work_shift}
								</label>
								<ScrollPagination
									Service={new WorkShiftService()}
									value={formData?.workShiftIds}
									nameVal="name"
									isMulti
									setData={(e) =>
										setFormData((prev) => ({ ...prev, workShiftIds: e }))
									}
								/>
							</Col>
						)}
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.branch}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddBranchModal;
